import { getDevicePixelRatio } from '../Device'

export const getImageUrl = (url, def = getDevicePixelRatio()) =>
  (url ?? '').replace(/^https?:/, '').replace(/(\.[a-zA-Z]+)$/, `-${def}$1`)
